





















import { Vue, Component, Emit } from "vue-property-decorator";
import User from "@/controller/user";

@Component
export default class UserTableUserRolePicker extends Vue {
  roles: string[] = User.getUserRoles();

  onClickEdit(event: Event, role: string) {
    this.emitClick(role);
  }

  @Emit("click")
  emitClick(role: string) {
    return role;
  }
}
